import _PublicationContentFTR, {
    GetFTRElements,
    GetFTRSelectors,
    GetFTRClassList,
    GetFTRTexts,
} from './publication-content/ts';

import GetFtrEntitlements from './axel-publication-content/js/GetFtrEntitlements.js';
import GetFtrUpdates from './axel-publication-content/js/GetFtrUpdates.js';

export {
    _PublicationContentFTR as PublicationContentFTR,
    GetFtrEntitlements,
    GetFtrUpdates,
    GetFTRElements,
    GetFTRSelectors,
    GetFTRClassList,
    GetFTRTexts,
};

export default _PublicationContentFTR;
